import { Modal } from "pepsico-ds";
import "./ModalForumDetailPage.css";
import Loading from "../../../../../utils/Loader";
import { Box, Typography } from "@mui/material";

const ModalForumDetailPage = ({
  forumModal,
  setForumModal,
  handlePublish,
  isPublishing,

  children,
  text,
}) => {
  return (
    <Modal
      className="forum-modal"
      onCloseModal={() => setForumModal(false)}
      hideCloseButton={false}
      showModal={forumModal}
      showAuxiliaryButton={false}
      showTertiaryButton={false}
      showLink={false}
      // auxiliaryButtonProps={{}}
      title="Review & Confirm"
      type="L"
      showPrimaryButton={true}
      showSecondaryButton={true}
      primaryButtonProps={{
        text: text,
        variant: "primary",
        onClick: handlePublish,
      }}
      secondaryButtonProps={{
        text: "Go Back",
        variant: "secondary",
        onClick: () => setForumModal(false),
      }}
      text="Please review your page"
    >
      {isPublishing && <Loading />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          marginTop: "12px",
        }}
      >
        {children}
      </Box>
    </Modal>
  );
};
export default ModalForumDetailPage;
